import React, { useState } from "react";
import styles from "../Table.module.css";
import Spinner from "../Spinner";
import Select from "react-select";

const headers = ["Category", "Weight", "Rate", "Amount", "Description"];

const RateCutTab = ({ selectedCustomer }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [issueList, setIssueList] = useState([]);

  return (
    <div className={styles.tableContainer}>
      {/* <table className={styles.table}>
        <thead>
          <tr>
            {headers?.map((header, index) => (
              <th key={index}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td
                colSpan="5"
                style={{
                  padding: "20px",
                  textAlign: "center",
                  verticalAlign: "middle",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <Spinner />
                  <span>Loading issues...</span>
                </div>
              </td>
            </tr>
          ) : issueList && issueList.length > 0 ? (
            issueList.map((issue, index) => (
              <tr key={issue.InvoiceId || index}>
                <td>{index + 1}</td>
                <td>{issue.Date || "-"}</td>
                <td>{issue.TransactionType || "-"}</td>
                <td>{issue.TransactionNo || "-"}</td>
                <td>{issue.TransactionNo || "-"}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5">No Issues Available</td>
            </tr>
          )}
        </tbody>
      </table> */}
      <div style={{display: "flex", gap: "10px"}}>
        <div style={{marginLeft: "1px", width: "12%"}}>
          <Select></Select>
        </div>
        <div>
          <input type="text" style={{border: "1px solid #ccc", height: "39px"}} placeholder="Weight" />
        </div>
        <div>
          <input type="text" style={{border: "1px solid #ccc", height: "39px"}} placeholder="Rate" />
        </div>
        <div>
          <input type="text" style={{border: "1px solid #ccc", height: "39px"}} placeholder="Amount" />
        </div>
        <div>
          <input type="text" style={{border: "1px solid #ccc", height: "39px"}} placeholder="Description"/>
        </div>
      </div>
    </div>
  );
};

export default RateCutTab;
